import React, { Fragment } from "react";

import { MDBModal } from "mdbreact";
import { useState } from "react";
import { useEffect } from "react";
import url from "../config/Config";

export const MenuLeftSidebar = ({ categorias, modalSidebarLeft, stateModalSidebarLeft }) => {

    useEffect(() => {
        if (modalSidebarLeft) {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        };
    }, [modalSidebarLeft]);

    return (
        <MDBModal
            isOpen={modalSidebarLeft}
            tabIndex="-1"
            className="fixed left-0 top-0 h-full w-[100%] lg:h-screen lg:w-96 lg:max-w-full m-0 bg-white shadow-lg"
            toggle={() => {
                stateModalSidebarLeft();
            }}
            contentClassName="h-full lg:h-auto"

        >
            <div className="h-full lg:h-screen flex flex-col relative">
                <div className="flex items-center justify-between bg-secondary-personalize px-4 py-4">
                    <div className="w-40 h-8 lg:h-16 overflow-hidden relative">
                        <a
                            href={
                                "/" +
                                "?e=".concat(
                                    localStorage.getItem("empresa")
                                )
                            }
                        >
                            <img
                                src="/img/logo-fondo.png"
                                alt="Logo"
                                className="absolute top-3 lg:top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                            />
                        </a>
                    </div>
                    <span
                        className="cursor-pointer"
                        onClick={() => stateModalSidebarLeft()}
                    >
                        <i className="fas fa-times text-xl text-white"></i>
                    </span>
                </div>

                <div className="px-4 mt-3">
                    <p className="text-lg font-bold uppercase">
                        Categorías
                    </p>
                    <ul className="space-y-2 mt-3">
                        {
                            categorias.length > 0 && categorias.map( (category, index) => (
                                <li key={index}>
                                    <a  href={
                                            `/categoria/${category.IdCategoria}/${category.Nombre}/1?e=` +
                                            localStorage.getItem("empresa")
                                        } className="text-gray-800 text-lg  flex items-center gap-1">
                                        <span className="flex-1">{ url.capitalizeWords( category.Nombre ) }</span>
                                        <i className="fas fa-chevron-right"></i>
                                    </a>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </MDBModal>
    );
};
